import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { SegmentTypes } from '../../../models/itinerary';
import { AppState } from '../../../store/model';
import { findSegment as findSegmentDetails } from '../../../store/reducers/segment-details/selectors';
import { Sector } from '../../lab/Sector';
import { getIconByType } from '../../SegmentIcon';
import { OptionsDesktop } from './OptionsDesktop';
import { isSaviSelectIntl } from '../../../store/reducers/itinerary/selectors';
import {
  getASegmentDetailsForSaviSelectIntlCar,
  getASegmentDetailsForSaviSelectIntlHotel,
  getSegmentTypeForSaviSelectIntl,
} from '../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  segmentId: number;
}

interface StateProps {
  title: string;
  type: SegmentTypes;
  showDisclaimer?: boolean;
}

interface ContentDesktopProps extends OwnProps, StateProps {}

class ContentDesktopBase extends PureComponent<ContentDesktopProps> {
  public render() {
    const { title, type, segmentId, showDisclaimer } = this.props;

    return (
      <Sector type={type} icon={getIconByType(type)} header={title}>
        <OptionsDesktop
          segmentId={segmentId}
          showDisclaimer={showDisclaimer ? showDisclaimer : false}
        />
      </Sector>
    );
  }
}

const mapStateToProps = (
  state: AppState,
  { segmentId }: ContentDesktopProps,
): StateProps => {
  if (!isSaviSelectIntl(state)) {
    const { title, type } = findSegmentDetails(segmentId)(state);
    return {
      title,
      type,
      showDisclaimer: false,
    };
  } else {
    const type = getSegmentTypeForSaviSelectIntl(segmentId)(state);
    let title = '';
    let showDisclaimer = false;

    if (type === 'Hotel') {
      const city = getASegmentDetailsForSaviSelectIntlHotel(segmentId)(state)!
        .cityName;
      title = `Stay in ${city}`;
      showDisclaimer = true;
    } else if (type === 'Car') {
      const city = getASegmentDetailsForSaviSelectIntlCar(segmentId)(state)!
        .pickupCityName;
      title = `Rental car in ${city}`;
    }

    return {
      title: title,
      type: type,
      showDisclaimer: showDisclaimer,
    };
  }
};

export const ContentDesktop = connect(mapStateToProps)(ContentDesktopBase);
